var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card-in 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1665 11.6665V73.3332C12.1665 76.0948 14.4048 78.3332 17.1665 78.3332H27.1665V11.6665H12.1665Z",
    fill: "#2E8FFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.1665 1.6665H13.8332C7.39984 1.6665 2.1665 6.9015 2.1665 13.3332C2.1665 17.9732 4.89817 21.9732 8.83317 23.8482V19.9598C6.81984 18.4365 5.49984 16.0465 5.49984 13.3332C5.49984 8.73817 9.23817 4.99984 13.8332 4.99984H67.1665C71.7615 4.99984 75.4998 8.73817 75.4998 13.3332C75.4998 16.0465 74.1798 18.4365 72.1665 19.9598V23.8482C76.1015 21.9748 78.8332 17.9748 78.8332 13.3332C78.8332 6.9015 73.5998 1.6665 67.1665 1.6665Z",
    fill: "#2E8FFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M68.8333 11.6665H40.5V78.3332H63.8333C66.595 78.3332 68.8333 76.0948 68.8333 73.3332V11.6665ZM55.5 63.3332C55.5 64.2548 54.7533 64.9998 53.8333 64.9998C52.9133 64.9998 52.1667 64.2548 52.1667 63.3332V46.6665C52.1667 45.7448 52.9133 44.9998 53.8333 44.9998C54.7533 44.9998 55.5 45.7448 55.5 46.6665V63.3332Z",
    fill: "#2E8FFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.fe3002ecc07dbb3c1d36463b8a917e54.svg";
export { ForwardRef as ReactComponent };